import { render, staticRenderFns } from "./PostEditVo.vue?vue&type=template&id=679e38e4&scoped=true&"
import script from "./PostEditVo.vue?vue&type=script&lang=js&"
export * from "./PostEditVo.vue?vue&type=script&lang=js&"
import style0 from "./PostEditVo.vue?vue&type=style&index=0&id=679e38e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679e38e4",
  null
  
)

export default component.exports